import { useState } from "react";

import { Input } from "~/components/Input";
import { Select } from "~/components/Select";

export const SourceSelect: React.FC = () => {
  const [value, setValue] = useState("");
  return (
    <>
      <Select
        label="Where did you hear about Knoword?"
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
      >
        <option value="">Please select one (optional)</option>
        <option value="colleague-teacher">A colleague or teacher</option>
        <option value="friend-classmate">A friend or classmate</option>
        <option value="workshop">A professional development workshop</option>
        <option value="online-search">An online search</option>
        <option value="social-media">Social media</option>
        <option value="blog-article">An education blog or article</option>
        <option value="school-newsletter">
          A school newsletter or website
        </option>
        <option value="ad">An online ad</option>
        <option value="other">Other (please specify)</option>
      </Select>

      {value === "other" ? (
        <Input
          key="other"
          name="source"
          placeholder="Tell us how you found out about Knoword"
          className="w-full"
        />
      ) : (
        <input type="hidden" name="source" value={value} />
      )}
    </>
  );
};
